export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '03131ae1-3041-42fc-8144-0d89e650896e';
export const MODAL_CLOSE_SEC = 2.5;
